import api from '../api'

export default {
    namespaced: true,
    state: {
        channelList: [],
        channelListTotal: 0,
    },
    mutations: {
        setDataChannelList(state, info) {
            state.channelList = info.beanList;
            state.channelListTotal = info.total
        }
    },
    actions: {
        getChannelList({commit}, params) {
            return api.armourPost('/v/list', '渠道列表列表', params).then(res => {
                commit('setDataChannelList', res.data)
            })
        },
        addChannel({dispatch}, {params,page}) {
            debugger
            return api.armourPost('/v/add', '新增渠道', params).then(()=>{
                dispatch('getChannelList',{page})
            })
        },
        updateChannel({dispatch}, {params,page}) {
            return api.armourPost('/v/update', '修改渠道', params).then(()=>{
                dispatch('getChannelList',{page})
            })
        },
        deleteChannel({dispatch}, {id,page}) {
            return api.armourPost('/v/del', '删除渠道', {id:id}).then(()=>{
                dispatch('getChannelList',{page})
            })
        },
        channelControl({dispatch}, {channelId,adOpen,page}) {
            return api.armourPost('/v/close', '渠道操作', {id:channelId,adOpen:adOpen}).then(()=>{
                dispatch('getChannelList',{page})
            })
        }
    }
}